import { Button } from '@material-ui/core';
import 'jspdf-autotable';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import {
  changeInsert,
  documentRequest,
  resetPage as resetPageRequest,
} from '~/store/ducks/document/actions';
import { Container, SearchButton, StyledTextField } from './styles';
import Table from './Table';

const ManterAtividadesTratamentoDados: React.FC = () => {
  const dispatch = useDispatch();

  const { company, token } = useSelector<ApplicationState, any>(
    state => state.auth,
  );

  const [form, setForm] = useState<{ name: string }>({
    name: '',
  });

  const handleChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const target = event.target;
      const name = target.name;

      setForm({
        ...form,
        [name]: target.value,
      });
    },
    [form],
  );

  const documentsData = useSelector<ApplicationState, any>(
    state => state.document,
  );

  const getDocument = useCallback(() => {
    dispatch(
      documentRequest({
        company: company?.country_company_id,
        newPage: 0,
        rowsPerPage: 5,
        pageNm: form.name,
      }),
    );
  }, [company, dispatch, form.name]);

  useEffect(() => {
    getDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentsData.resetPage]);

  useEffect(() => {
    getDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableData = useMemo(() => {
    try {
      const data = documentsData.data.map((el: any) => ({
        page_id: el.page_id,
        type: el.page_type_fl == 1 ? 'Document' : 'Sanfona',
        name: el.page_nm,
        status: el.status_fl,
        acao: '',
        total_itens: el.total_itens,
      }));

      return data.length ? data : [];
    } catch (error) {}
  }, [documentsData]);

  return (
    <Container>
      <HeaderPage pageTitle="Documentos" />

      <div className="main-content-solicitar-ajuda-dpo">
        <h1 className="titululo-atividades">Filtrar lista de documentos</h1>

        <div className="search-event">
          <StyledTextField
            onChange={handleChangeInput}
            id="nome"
            label="Nome"
            name="name"
            value={form.name}
            variant="outlined"
            className="TextField-lgpd"
          />

          <SearchButton
            onClick={() => {
              dispatch(resetPageRequest(1));
              getDocument();
            }}
          >
            Pesquisar
          </SearchButton>
        </div>

        <p className="document-list">Lista de documento</p>

        <Table
          ResetPage={documentsData.resetPage}
          className="table-lgpd"
          getOrderHandleChangePage={(value: number, rowsPerPage: number) =>
            dispatch(
              documentRequest({
                company: company?.country_company_id,
                newPage: value,
                rowsPerPage: 5,
                pageNm: form.name,
              }),
            )
          }
          data={tableData}
        />

        <div className="buttonGroup">
          <Button
            data-toggle="modal"
            data-target="#exampleModal"
            variant="outlined"
            className="button-continue ajuda"
            onClick={() => dispatch(changeInsert('insert'))}
          >
            Incluir atividades
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default ManterAtividadesTratamentoDados;
